<template>
  <div>
    <p>{{ $t('prosumerBonus.identification.subTitle') }}</p>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6">
        <masked-text-box :label="$t('prosumerBonus.identification.workFileNumber')" mask="######" pattern="[0-9]{6}" required :labelTooltip="$t('prosumerBonus.identification.workFileNumberTooltip')" data-cy="works-file--id" v-model="worksFileId"></masked-text-box>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6">
        <text-box :label="$t('prosumerBonus.identification.eanCode')" :rules="{ 'ean-code-validator': true, required: true }" placeholder="541447856985698523" :labelTooltip="$t('prosumerBonus.identification.eanCodeTooltip')" v-model="eanCode"></text-box>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch, Inject } from 'vue-property-decorator'
import { Identification } from '@/models'
import { YesNoMaybeSelection } from '@ores/vue-library'

@Component
export default class IdentificationForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: false }) public readonly value!: Identification | null
  //#endregion

  //#region [Computed]
  public get worksFileId(): string | null {
    return this.value ? this.value.worksFileId : null
  }
  public set worksFileId(val: string | null) {
    this.change(val, this.eanCode)
  }

  public get eanCode(): string | null {
    return this.value ? this.value.eanCode : null
  }
  public set eanCode(val: string | null) {
    this.change(this.worksFileId, val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(worksFileId: string | null, eanCode: string | null): Identification | null {
    if (worksFileId !== null || eanCode !== null) {
      return { worksFileId, eanCode }
    } else {
      return null
    }
  }
  //#endregion
}
</script>